import React from 'react';
import PropTypes from 'prop-types';

export const QuestionText = ({ title, subtitle }) => {
  return (
    <div className="question d-flex flex-column align-items-center">
      <div className="question-text d-flex flex-column align-items-center justify-content-center w-100 p-2">
        <h1 className="title">{title}</h1>
        <p className="mb-0 text-center">{subtitle}</p>
      </div>
    </div>
  );
};

QuestionText.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};
